import { NotificationTable } from '@notification/components'
import { paths } from '@organization/router'
import { TitleSection } from '@shared/components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from 'react-router-dom'

import { NotificationHeader } from '../components'

export const NotificationsPage = () => {
  const { t } = useTranslation()
  const [{ count, isLoading }, onUpdate] = useState({
    count: 0,
    isLoading: false
  })
  const navigate = useNavigate()

  return (
    <>
      <TitleSection
        title={t('menu.notifications')}
        count={count}
        isLoading={isLoading}
      >
        <NotificationHeader />
      </TitleSection>

      <NotificationTable
        onUpdate={onUpdate}
        onClick={(id) => navigate(paths.notifications.details(id))}
      />
    </>
  )
}
